import React from 'react';

const NvidiaDGXSpark = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Announced at CES 2025, the NVIDIA DGX Spark is a desktop AI supercomputer about the
      size of a Mac mini. It runs a 1,000-TOPS AI processor, supports up to 128GB of unified
      memory, and can run large language models locally - no cloud required. NVIDIA is calling
      it "a data centre on your desk." The price is still to be confirmed, but the target
      market is clear: researchers and developers who want serious AI compute without
      a serious cloud bill.
    </p>

    <h2>What's inside</h2>
    <p>
      DGX Spark is built on the Grace Blackwell Superchip - the same architecture that
      powers NVIDIA's largest data centre systems, just scaled down into a compact form.
      Key specs:
    </p>
    <ul>
      <li><strong>GPU:</strong> GB10 Grace Blackwell Superchip</li>
      <li><strong>AI Performance:</strong> 1,000 TOPS (trillion operations per second)</li>
      <li><strong>Memory:</strong> Up to 128GB unified (CPU and GPU share the same pool)</li>
      <li><strong>Connectivity:</strong> NVIDIA ConnectX networking for linking multiple units</li>
    </ul>
    <p>
      The "unified memory" part matters a lot. Most desktop systems have separate CPU RAM
      and GPU VRAM, which creates a bottleneck moving data between them. DGX Spark's unified
      pool means a 70-billion parameter model can sit entirely in memory and run at
      full speed.
    </p>

    <h2>What you can actually do with it</h2>
    <p>
      The device is powerful enough to run models like Llama 3 70B, Mistral 7B, Mixtral
      8x7B, and coding assistants locally - fully offline, fully private. For organisations
      with data privacy requirements, that alone is valuable.
    </p>
    <p>
      NVIDIA also supports NIM (NVIDIA Inference Microservices), which means you can
      deploy pre-optimised containerised AI tools with minimal setup. Think of it as
      an app store for AI models, optimised specifically for DGX hardware.
    </p>

    <h2>Who it's actually for</h2>
    <p>
      Jensen Huang described it as a workstation for "AI researchers and scientists." The
      practical target is:
    </p>
    <ul>
      <li>Developers building and testing AI applications who want a dedicated local machine</li>
      <li>Researchers who can't send sensitive data to cloud APIs</li>
      <li>Companies wanting an on-premises AI server without a full rack installation</li>
      <li>Anyone tired of GPU cloud costs for iterative development work</li>
    </ul>

    <h2>The bigger picture</h2>
    <p>
      DGX Spark reflects a broader trend: as AI models become more efficient, running them
      on local hardware becomes practical. What required a data centre in 2022 can now sit
      on a desk. NVIDIA is smart to own that entire market, from the smallest workstation
      to the largest cloud infrastructure.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        The shift toward "edge AI" - running models on local devices rather than in the
        cloud - is real and accelerating. DGX Spark is NVIDIA's answer to developers who
        want powerful, private, cost-predictable AI compute. If it's priced right, it could
        become the workstation of choice for a generation of AI developers.
      </p>
    </div>
  </article>
);

export default NvidiaDGXSpark;
